import { useEffect, useState } from 'react';
import useUploadState from 'FeatureModules/Document/hooks/useUploadState';

const useUploadItem = id => {
  const { fileMap } = useUploadState();
  const [item, setItem] = useState(fileMap[id] || {});
  const { progress, success, error } = fileMap[id] || {};

  useEffect(() => {
    setItem(fileMap[id] || {});
  }, [fileMap, progress, success, error]); //eslint-disable-line

  return item;
};

export default useUploadItem;
